import filetableImage from "../../../image/dashboard.png";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import FeedOutlinedIcon from "@mui/icons-material/FeedOutlined";
import BasicLayout from "../../../components/layout/BasicLayout";
import LinkTileCard from "../../../components/ui/LinkTileCard";

interface DashboardType {
  hasLeavingQuestionnaire: boolean;
}

const Dashboard = ({ hasLeavingQuestionnaire }: DashboardType) => {
  const theme = useTheme();
  return (
    <BasicLayout>
      <Container maxWidth="lg">
        <Grid container justifyContent="center">
          <Grid size={{ xs: 12, md: 8 }}>
            <Grid size={{ xs: 12 }}>
              <Card>
                <CardMedia
                  sx={{
                    height: 170,
                    [theme.breakpoints.up("sm")]: {
                      height: 250,
                    },
                  }}
                  component="img"
                  image={filetableImage}
                  title="FileTableImage"
                />

                <CardContent
                  sx={{
                    padding: theme.spacing(3),
                  }}
                >
                  <Typography variant="h2" mb={1}>
                    Rozcestník
                  </Typography>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={3}
                  >
                    <Grid size={{ xs: 12 }}>
                      <LinkTileCard
                        to="/dotazniky"
                        icon={
                          <FeedOutlinedIcon
                            fontSize="medium"
                            sx={{
                              position: "relative",
                              top: "2px",
                              color: "#CC0000",
                            }}
                          />
                        }
                        title="Nástup do práce"
                        subtitle="Formulář a důležité informace před nástupem do práce."
                      />
                    </Grid>

                    {hasLeavingQuestionnaire && (
                      <Grid size={{ xs: 12 }}>
                        <LinkTileCard
                          to="/dotaznikvystup"
                          icon={
                            <AssignmentReturnIcon
                              sx={{
                                position: "relative",
                                top: "2px",
                                color: "#CC0000",
                              }}
                              fontSize="medium"
                            />
                          }
                          title="Výstupní dotazník"
                          subtitle="Formulář pro tvojí zpětnou vazbu"
                        />
                      </Grid>
                    )}

                    <Grid size={{ xs: 12 }}>
                      <LinkTileCard
                        to="/dokumenty"
                        icon={
                          <FolderOpenIcon
                            fontSize="medium"
                            sx={{ color: "#CC0000" }}
                          />
                        }
                        title="Šanon"
                        subtitle="Zde najdeš všechny dokumenty související s tvojí prací v Seznamu."
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </BasicLayout>
  );
};

export default Dashboard;
